import * as React from 'react';
import { deprecatedComponent } from '../react/components/core/deprecated-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
/**
 * @deprecated
 * use <Icon iconType="" /> instead
 **/ const IconLiveChat = deprecatedComponent({
    displayName: 'IconLiveChat',
    // @ts-ignore
    root: (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em"
        }, props), /*#__PURE__*/ React.createElement("path", {
            d: "M8.82389 18.5881L9.01788 17.8636C8.84078 17.8162 8.65245 17.8353 8.48848 17.9172L8.82389 18.5881ZM4 21L3.25754 20.8939C3.21809 21.1701 3.33517 21.4453 3.56147 21.6084C3.78777 21.7715 4.08591 21.7956 4.33541 21.6708L4 21ZM4.65323 16.4274L5.39569 16.5335C5.43177 16.2809 5.33702 16.0274 5.14418 15.8604L4.65323 16.4274ZM12 19.75C17.7722 19.75 22.75 15.98 22.75 11H21.25C21.25 14.8565 17.2735 18.25 12 18.25V19.75ZM8.6299 19.3125C9.69141 19.5968 10.8246 19.75 12 19.75V18.25C10.9549 18.25 9.95209 18.1137 9.01788 17.8636L8.6299 19.3125ZM4.33541 21.6708L9.1593 19.2589L8.48848 17.9172L3.66459 20.3292L4.33541 21.6708ZM3.91077 16.3213L3.25754 20.8939L4.74247 21.1061L5.39569 16.5335L3.91077 16.3213ZM1.25 11C1.25 13.3485 2.38036 15.4514 4.16228 16.9944L5.14418 15.8604C3.63223 14.5512 2.75 12.8408 2.75 11H1.25ZM12 2.25C6.22776 2.25 1.25 6.01999 1.25 11H2.75C2.75 7.14346 6.72654 3.75 12 3.75V2.25ZM22.75 11C22.75 6.01999 17.7722 2.25 12 2.25V3.75C17.2735 3.75 21.25 7.14346 21.25 11H22.75Z",
            fill: "black"
        })),
    description: 'The Inline SVG Icon API is deprecated, use the Icon component instead'
});

export { IconLiveChat };
